import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.superBatchManagement;

export const superBatchesSelector = createSelector(
  (state) => baseSelector(state).superBatches,
  (superBatches) => superBatches
);

export const metaKeySelector = createSelector(
  (state) => baseSelector(state).metaKey,
  (metaKey) => metaKey
);

export const metaDataSelector = createSelector(
  (state) => baseSelector(state).metaData,
  (metaData) => metaData
);
